import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function H() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('camp');
    const lists: any[] = [
        {
            img: '/responsive/picture/camp/8_1.jpg',
            title: t('secH_list1_title'),
            desc: t('secH_list1_desc'),
        },
        {
            img: '/responsive/picture/camp/8_2.jpg',
            title: t('secH_list2_title'),
            desc: t('secH_list2_desc'),
        },
        {
            img: '/responsive/picture/camp/8_3.jpg',
            title: t('secH_list3_title'),
            desc: t('secH_list3_desc'),
        },
    ];
    return (
        <div id="camp-H" className={`camp-H camp-box ${css['camp-H']}`}>
            <h2 className="title">{t('secH_title')}</h2>
            <div className="img-box">
                <EFPicture src={'/responsive/picture/camp/8.jpg'} alt={t('secH_title')} />
            </div>
            <p className="desc">{t('secH_desc')}</p>
            <ul className="lists">
                {lists?.map((list: any, k: number) => (
                    <li className="list" key={k}>
                        <h3 className="list-title">{list?.title}</h3>
                        <div className="list-info">
                            <div className="list-img">
                                <EFPicture src={list?.img} alt={list?.title} />
                            </div>
                            <p className="list-desc desc">{list?.desc}</p>
                        </div>
                    </li>
                ))}
            </ul>
            <p className="desc tip">
                {t.rich('secH_text', {
                    a: (a: string) => (
                        <Link className="a-link" href={t('secH_text_link')}>
                            {a}
                        </Link>
                    ),
                })}
            </p>
        </div>
    );
}
